// extracted by mini-css-extract-plugin
export default {"overlay":"common-overlay__overlay__s8wmR","parent":"common-overlay__parent__bKgix"};